var _path, _path2, _path3, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M34.532 27.129V10.706a5.669 5.669 0 00-5.669-5.669H13.658a5.669 5.669 0 00-5.669 5.669v26.348"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M7.988 37.053l4.397-4.13 4.442 4.172 4.442-4.172 4.396 4.13 4.431-4.162 4.436 4.167"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M16.534 21.335l9.538-9.538"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 16.746,
    cy: 12.095,
    r: 0.685
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 25.773,
    cy: 21.322,
    r: 2.169
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxInvoice);
export default __webpack_public_path__ + "static/media/taxInvoice.3ef6ae7fe72973106cc03f88375b3dcd.svg";
export { ForwardRef as ReactComponent };